module.exports = __webpack_public_path__ + "img/error.20fa996c.svg";